export default 'https://tme.understood.org/assets/sock.107121b4.lottie'